import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function OffScreenIndicatorSvg({ className, width = 24, height = 72 }) {
    return (_jsx("svg", { width: width, height: height, viewBox: "0 0 24 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: classNames('text-brand-2 fill-current', className), children: _jsx("path", { d: "M12 0L24 25.2V64A8 8 0 0 1 16 72H8A8 8 0 0 1 0 64V25.2L12 0Z", fill: "currentColor" }) }));
}
